/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmListRowData } from './CrmListRowData';
import {
    CrmListRowDataFromJSON,
    CrmListRowDataFromJSONTyped,
    CrmListRowDataToJSON,
    CrmListRowDataToJSONTyped,
} from './CrmListRowData';
import type { CrmProjectIntegrationTypeData } from './CrmProjectIntegrationTypeData';
import {
    CrmProjectIntegrationTypeDataFromJSON,
    CrmProjectIntegrationTypeDataFromJSONTyped,
    CrmProjectIntegrationTypeDataToJSON,
    CrmProjectIntegrationTypeDataToJSONTyped,
} from './CrmProjectIntegrationTypeData';
import type { CrmProjectCategoryCountsData } from './CrmProjectCategoryCountsData';
import {
    CrmProjectCategoryCountsDataFromJSON,
    CrmProjectCategoryCountsDataFromJSONTyped,
    CrmProjectCategoryCountsDataToJSON,
    CrmProjectCategoryCountsDataToJSONTyped,
} from './CrmProjectCategoryCountsData';

/**
 * 
 * @export
 * @interface CrmProjectPageData
 */
export interface CrmProjectPageData {
    /**
     * 
     * @type {Array<CrmListRowData>}
     * @memberof CrmProjectPageData
     */
    items?: Array<CrmListRowData>;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectPageData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectPageData
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectPageData
     */
    total?: number;
    /**
     * 
     * @type {Array<CrmProjectIntegrationTypeData>}
     * @memberof CrmProjectPageData
     */
    integrationTypes?: Array<CrmProjectIntegrationTypeData>;
    /**
     * 
     * @type {CrmProjectCategoryCountsData}
     * @memberof CrmProjectPageData
     */
    categoryCounts?: CrmProjectCategoryCountsData;
}

/**
 * Check if a given object implements the CrmProjectPageData interface.
 */
export function instanceOfCrmProjectPageData(value: object): value is CrmProjectPageData {
    return true;
}

export function CrmProjectPageDataFromJSON(json: any): CrmProjectPageData {
    return CrmProjectPageDataFromJSONTyped(json, false);
}

export function CrmProjectPageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectPageData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CrmListRowDataFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'total': json['total'] == null ? undefined : json['total'],
        'integrationTypes': json['integrationTypes'] == null ? undefined : ((json['integrationTypes'] as Array<any>).map(CrmProjectIntegrationTypeDataFromJSON)),
        'categoryCounts': json['categoryCounts'] == null ? undefined : CrmProjectCategoryCountsDataFromJSON(json['categoryCounts']),
    };
}

export function CrmProjectPageDataToJSON(json: any): CrmProjectPageData {
    return CrmProjectPageDataToJSONTyped(json, false);
}

export function CrmProjectPageDataToJSONTyped(value?: CrmProjectPageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CrmListRowDataToJSON)),
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'integrationTypes': value['integrationTypes'] == null ? undefined : ((value['integrationTypes'] as Array<any>).map(CrmProjectIntegrationTypeDataToJSON)),
        'categoryCounts': CrmProjectCategoryCountsDataToJSON(value['categoryCounts']),
    };
}

